export default __webpack_public_path__ + "static/media/misc-books1-480w.76cfddbb.png";